import { Helmet } from 'react-helmet-async';

interface SEOProps {
    title?: string;
    description?: string;
    image?: string;
    url?: string;
    type?: string;
}

export function SEO({
    title = "Traskr - Job Hunt Tracker & AI Resume Matcher",
    description = "Supercharge your job search with Traskr. Track applications, visualize progress with Sankey diagrams, and get AI-powered resume matching scores.",
    image = "https://www.traskr.com/og-image.png",
    url = "https://www.traskr.com",
    type = "website"
}: SEOProps) {
    const siteTitle = title === "Traskr - Job Hunt Tracker & AI Resume Matcher" ? title : `${title} | Traskr`;

    return (
        <Helmet>
            {/* Standard metadata */}
            <title>{siteTitle}</title>
            <meta name="description" content={description} />
            <link rel="canonical" href={url} />

            {/* Open Graph / Facebook */}
            <meta property="og:type" content={type} />
            <meta property="og:url" content={url} />
            <meta property="og:title" content={siteTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:image" content={image} />

            {/* Twitter */}
            <meta property="twitter:card" content="summary_large_image" />
            <meta property="twitter:url" content={url} />
            <meta property="twitter:title" content={siteTitle} />
            <meta property="twitter:description" content={description} />
            <meta property="twitter:image" content={image} />
        </Helmet>
    );
}
